<template>
    <!-- List all areas of concern that have been added -->
    <section class="areasOfConcern"
             v-if="lead.areasOfConcern">

        <div class="commonlyProtectedAreas">

            <div class="commonlyProtectedArea noAreas" v-if="areasOfConcern.length < 1">
                <div class="commonlyProtectedArea-name">You haven't evaluated any areas</div>
            </div>

            <div v-for="area in areasOfConcern"
                 class="commonlyProtectedArea">
                <div class="commonlyProtectedArea-icon">
                    <img :src="area.image" />
                </div>
                <div class="commonlyProtectedArea-name">{{ area.name }}</div>
                <div class="commonlyProtectedArea-meta">
                    <div>
                        {{ area.accessibleFromGroundFloor ? 'Accessible' : 'Not Accessible' }}
                    </div>
                    <div>
                        {{ area.windowsThatOpen }}/{{ area.windows }} windows open
                    </div>
                </div>
                <div class="commonlyProtectedArea-edit">
                    <a href="javascript:;" @click="editArea(area)">Edit</a>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['lead']),

        areasOfConcern: state => {
            return state.lead.areasOfConcern
        }
    },
    methods: {
        ...mapActions([
            'expandAreaOfConcern',
            'closeAreaOfConcern',
            'deleteAreaOfConcern',
            'closeAreasOfConcern',
            'updateSystem',
            'save',
            'updateAreaOfConcern',
            'setAocSectionIndex'
        ]),

        editArea(area) {
            area.editing = true
            this.updateAreaOfConcern(area)
            this.$router.push('/assessment/areas-of-concern')
            this.setAocSectionIndex(1)
        },

        remove(index) {
            this.deleteAreaOfConcern(index).then(() => {
                this.save().then(() => {
                    this.updateSystem()
                })
            })
        }
    },
    mounted() {
        this.closeAreasOfConcern()
        // this.$watch('lead.areasOfConcern', (aocs) => {
        //     this.save().then()
        // })
    }
}
</script>

<style lang="css">

</style>
